import { useEffect, useState } from "react";
import { IoMdArrowDropright } from "react-icons/io";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import banner2 from "../assets/banner5.jpg";
import { getInlineLoader } from "../Helpers";

export default function MaintenanceBackupServicesPage() {
  const [ready, setReady] = useState(false);

  useEffect(() => setReady(true), []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const services = [
    {
      title: "Renewable Energy Solutions",
      desc: "We provide solutions and techniques to ensure the successful delivery of renewable and sustainable energy projects promptly.",
    },
    {
      title: "Solar Water Heater & Refrigerators",
      desc: "We install solar water heater systems and refrigerators for institutions, companies, hospitals, schools, and residential houses with full support.",
    },
    {
      title: "Solar Backup & Photovoltaic Systems",
      desc: "Installation, service of solar backup systems, and photovoltaic power plants for residential, industrial, commercial, and agricultural applications.",
      highlight: true, // Highlight this service
    },
    {
      title: "Solar Water Pumping System",
      desc: "Installation of solar water pumping systems with timely after-sales support.",
    },
    {
      title: "Solar Streetlights & Wind Power",
      desc: "Installation of solar streetlights and wind power systems with experienced engineering support.",
    },
    {
      title: "Electrical Installations",
      desc: "Residential, commercial, and industrial electrical installations and maintenance with over 5 years of experience.",
    },
    {
      title: "CCTV, Security & Fire Systems",
      desc: "Installation and servicing of CCTV, security, and fire systems across residential, commercial, and industrial sectors.",
    },
    {
      title: "Air Conditioning & Generator Services",
      desc: "DC, fuel forklift repair and servicing, PBX installation, voice support, and data installations.",
    },
  ];

  return (
    <section className="MainBodySection py-5 franno-page" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        {/* HERO */}
        <div className="row align-items-center mb-5">
          <div className="col-lg-6">
            <h1 className="fw-bold text-dark mb-3">Maintenance & Backup Services</h1>
            <h5 className="text-primary fw-semibold mb-3">VISION!</h5>
            <p className="text-secondary mb-4">
              To become a global, innovative, and competitive renewable energy enterprise providing total solutions at very affordable cost in Africa.
            </p>
            <button className="btn btn-primary d-inline-flex align-items-center gap-2">
              Contact Us <IoMdArrowDropright />
            </button>
          </div>
          <div className="col-lg-6">
            <div
              className="rounded-4 overflow-hidden"
              style={{
                height: "350px",
                background: `linear-gradient(145deg, rgba(0,0,0,.2), rgba(0,0,0,.5)), url(${banner2}) center/cover no-repeat`,
              }}
            />
          </div>
        </div>

        {/* PROFILE */}
        <div className="mb-5">
          <h3 className="fw-bold text-dark mb-3 text-center">DOUBLE F SMART ENERGIES ENTERPRISE</h3>
          <p className="text-secondary text-center mb-0">
            A renewable energy solutions company bringing power to Africa. 1.3 billion people live without electricity, 600 million in Sub-Saharan Africa. We develop clean, renewable energy projects and empower populations with sustainable power.
          </p>
        </div>

        {/* SERVICES */}
        <div className="mb-5">
          <h4 className="fw-bold text-dark mb-4 text-center">What We Do</h4>
          <div className="row g-4">
            {services.map((s, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div
                  className={`p-3 rounded-4 border shadow-sm h-100 ${
                    s.highlight ? "border-primary bg-primary-subtle" : "border-secondary-subtle bg-white"
                  }`}
                >
                  <IoCheckmarkCircleOutline size={22} className="text-primary mb-2" />
                  <h6 className="fw-bold text-dark">{s.title}</h6>
                  <p className="text-secondary mb-0">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* PROJECTS */}
        <div className="mb-5">
          <h4 className="fw-bold text-dark mb-3 text-center">Projects & Clients</h4>
          <p className="text-secondary text-center">
            Worked with corporate companies, institutions, government, and individuals. Examples include AKIBA Commercial Bank, NMB, Malawi Embassy, Bank of Africa, and installations across Mpanda/Katavi regions.
          </p>
        </div>

        {/* TESTIMONY */}
        <div className="mb-5 text-center p-4 rounded-4 shadow-sm bg-light">
          <h5 className="fw-bold text-dark mb-3">Customer Testimony</h5>
          <p className="text-secondary mb-0">
            "Working with DOUBLE F on our Maintenance & Backup Services projects was a great success. They have a competent team from consultation through installation and after-sales services." – SPOKESPERSON, BOA
          </p>
        </div>

        {/* CONTACT */}
        <div className="text-center mb-5">
          <h4 className="fw-bold text-dark mb-3">Contact Us</h4>
          <p className="text-secondary mb-2">DOUBLE F SMART ENERGIES ENTERPRISE – Dar es Salaam, Tanzania</p>
        </div>
      </div>
    </section>
  );
}